import React from 'react';
import './Dreams.css';

const Dreams = () => {
  const dreamBenefits = [
    "Accessing the unconscious mind",
    "Symbolism and metaphor can reveal insights into our emotional and psychological states",
    "Processing trauma and unresolved emotions",
    "Integration of the shadow self",
    "Gain insight into life transitions",
    "Conflict resolution",
    "Healing through self-reflection",
    "Creating a dialogue with the unconscious",
    "Guidance for personal growth",
    "Source of comfort and support"
  ];

  return (
    <div className="dreams">
      <div className="dreams-container">
        <div className="dreams-header">
          <h1>Dreams</h1>
          <p>
            Exploring the unconscious mind for deeper self-understanding and healing
          </p>
        </div>
        
        <div className="dreams-content">
          <div className="dreams-quote">
            <blockquote>
              "Dreams are the guiding words of the soul. Why should I henceforth not love my dreams and not make their riddling images into objects of my daily consideration?"
            </blockquote>
            <cite>— Carl Jung</cite>
          </div>
          
          <div className="dreams-intro">
            <p>
              Understanding dreams can be a deeply insightful and powerful tool for personal healing, 
              as they often serve as a window into the subconscious mind. Dreams are rich with symbolism, 
              emotions, and experiences that can reveal hidden parts of ourselves—parts that we might not 
              fully acknowledge or understand in our waking life.
            </p>
            <p>
              Here's how exploring dreams in therapy can aid in the healing process:
            </p>
          </div>

          <div className="dreams-benefits">
            <div className="benefits-grid">
              {dreamBenefits.map((benefit, index) => (
                <div key={index} className="benefit-item">
                  <span className="benefit-icon">✨</span>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="dreams-credential">
            <h2>Professional Training</h2>
            <div className="credential-card">
              <div className="credential-icon">🎓</div>
              <div className="credential-content">
                <h3>Beginning Dream Patterning Course</h3>
                <p className="institution">The Assisi Institute: The International Center for the Study of Archetypal Patterns</p>
                <p className="year">2023-2024</p>
              </div>
            </div>
          </div>

          <div className="dreams-approach">
            <h2>My Approach to Dream Work</h2>
            <p>
              In our sessions, I create a safe and supportive space for exploring your dreams. 
              Together, we'll examine the symbols, emotions, and patterns that emerge, helping 
              you gain deeper insights into your inner world and supporting your healing journey.
            </p>
            <p>
              Whether you're working through specific challenges, seeking personal growth, or 
              simply curious about what your dreams might reveal, dream work can be a powerful 
              complement to traditional therapeutic approaches.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dreams;
